var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lvmmed-oauth-callback"},[_c('div',{staticClass:"callback-card"},[_c('h2',[_vm._v("Liên kết LVMMED")]),_c('p',[_vm._v(_vm._s(_vm.statusMessage))]),(_vm.canClose)?_c('button',{staticClass:"btn-close",attrs:{"type":"button"},on:{"click":_vm.closeWindow}},[_vm._v("Đóng cửa sổ")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }